import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'floTruncate' })
export class FloTruncatePipe implements PipeTransform {
  transform(value: string, limit = 60, trail = '...'): string {
    return value && value.length > limit ? value.substring(0, limit) + trail : value
  }
}
